module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dave Grossman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" A former army Ranger and paratrooper, Lt. Col. Dave Grossman taught psychology at West Point and was a Professor of Military Science at Arkansas State University."), _c('BR'), _c('BR'), _vm._v(" The author's website, Grossman On Truth, amplifies and extends the material covered in his books and is regularly updated with new, topical information on the subject. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/qyFYsQ/tc-custom/9781497629202.jpg?1733037586550",
      "alt": "This image is the cover for the book On Killing"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("On Killing\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A controversial psychological examination of how soldiers’ willingness to kill has been encouraged and exploited to the detriment of contemporary civilian society.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Psychologist and US Army Ranger Dave Grossman writes that the vast majority of soldiers are loath to pull the trigger in battle. Unfortunately, modern armies, using Pavlovian and operant conditioning, have developed sophisticated ways of overcoming this instinctive aversion."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The mental cost for members of the military, as witnessed by the increase in post-traumatic stress, is devastating. The sociological cost for the rest of us is even worse: Contemporary civilian society, particularly the media, replicates the army’s conditioning techniques and, Grossman argues, is responsible for the rising rate of murder and violence, especially among the young."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Drawing from interviews, personal accounts, and academic studies, "), _c('i', [_vm._v("On Killing")]), _vm._v(" is an important look at the techniques the military uses to overcome the powerful reluctance to kill, of how killing affects the soldier, and of the societal implications of escalating violence."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0